import { render } from "./UpdateEvent.vue?vue&type=template&id=3d3383f8"
import script from "./UpdateEvent.vue?vue&type=script&lang=js"
export * from "./UpdateEvent.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__